"use client";

import {usePathname} from "next/navigation";
import {useEffect, useState} from "react";
import {isSameNextAppPath} from "./urlUtils";

export const useIsHrefCurrentPath = (href?: string) => {
	const currentPath = usePathname();
	const [isHrefCurrentPage, setIsHrefCurrentPage] = useState<boolean>(false);

	useEffect(() => {
		if (href) {
			setIsHrefCurrentPage(isSameNextAppPath(currentPath, href));
			return;
		}

		setIsHrefCurrentPage(false);
	}, [currentPath, href]);

	return isHrefCurrentPage;
};
